import React, { useEffect, useState } from 'react';
import { Textarea } from '@chakra-ui/react';
import { FormControl, Text, Tooltip } from '@chakra-ui/react';

const InputTextArea = ({
  id,
  name,
  type,
  label,
  register,
  isInvalid,
  isRequired,
  placeholder,
  errorMessage,
  defaultValue,
}) => {
  const [labelTooltip, setLabelTooltip] = useState(false);
  const [errorTooltip, setErrorTooltip] = useState(false);

  useEffect(() => {
    setLabelTooltip(
      document?.getElementById(name)?.offsetWidth < document?.getElementById(name)?.scrollWidth,
    );
    setErrorTooltip(
      document?.getElementById(`${name}err`)?.offsetWidth <
        document?.getElementById(`${name}err`)?.scrollWidth,
    );
  });

  return (
    <FormControl id={id} isInvalid={isInvalid}>
      <Tooltip label={labelTooltip ? label : ''} area-label="A Tooltip" placement="top-start">
        <Text
          mb={1.5}
          id={name}
          fontSize="sm"
          overflow="hidden"
          whiteSpace="nowrap"
          color="textSecondary"
          textOverflow="ellipsis">
          {isRequired ? <b style={{ color: '#E53E3E' }}>* </b> : null}
          {label}
        </Text>
      </Tooltip>
      <Textarea
        id={id}
        type={type}
        name={name}
        fontSize="md"
        bg="formInputBG"
        variant="outline"
        borderRadius="sm"
        placeholder={placeholder}
        defaultValue={defaultValue}
        focusBorderColor="primary.300"
        {...register(name)}
      />
      <Tooltip
        label={errorTooltip ? errorMessage : ''}
        area-label="A Tooltip"
        placement="bottom-start">
        <Text
          id={`${name}err`}
          mb={1.5}
          fontSize="xs"
          color="invalid"
          overflow="hidden"
          whiteSpace="nowrap"
          textOverflow="ellipsis">
          {errorMessage}
        </Text>
      </Tooltip>
    </FormControl>
  );
};

export default InputTextArea;
